export default "__VITE_ASSET__39f9c5f1__"